export const contentData = {
  spanish:{
    layout:{
      title:'Efirma',
      navigation:[
          {name:'Tablas de Control',path:'/controltables'},
          {name:'Detalles',path:'/controltables/details/:id'},
      ],
      menu:null
    },
    modals:{
      warning_delete_file:{
        title:'¿Estás seguro?',
        message:'¿Realmente quieres eliminar este registro? Este proceso no puede ser revertido',
        cancelButton:'Cancelar',
        deleteButton:'Eliminar'
      },
      edit_service:{
        title:'Editar servicio',
        button:'Guardar',
        cancelButton:'Cancelar'
      }
    },
    basicform:{
      title:'Información',
      button:null,
      nodata:'Sin Registro',
      headers:{
        fixedHeaderA: ['Nombre','RFC','Estatus','Clasificación','Fecha de Solicitud',
        'Fecha Estimada de Termino','Horas Cotizadas','Documentación Adjunta','Descripción del Servicio',
        'Nombre','Fecha Vigencia','Estatus de Vigencia'],
        fixedHeaderB: null,
        varHeader: ['Tramite','Acuse','Comentarios','Respuesta Cliente','Comentario Cliente',
        'Responsable','Notas','Horas Extra', 'Comprobante Horas', 'Cargos Extra', 'Comprobante Cargo', 
        'Cargo a Cobranza', 'Fecha de Completado'],
        extra: 'Completado'
      },

    }
  }
}
